export default __webpack_public_path__ + "static/media/Khusnullin_Marat.0bab632f.webp";